import CLFiles, { LogLevelName } from "@cloudike/web_files"

import { USER_TOKEN_KEY_IN_STORAGE } from "../constants/user"
import { getCurrentAppConfigApiHost } from "../config/appConfig"

const options = {
  logLevel: LogLevelName.TRACE
}

const getConfig = () => {
  return {
    authToken: localStorage.getItem(USER_TOKEN_KEY_IN_STORAGE) || undefined,
    baseUrl: getCurrentAppConfigApiHost(),
    userAgent: `web-client`,
  }
}

export const getFilesSdk = (): CLFiles => {
  let sdk = null

  try {
    sdk = CLFiles.init(options, getConfig())
  } catch (e) {
    console.error(`Couldn't init files sdk`, e)
  }

  return sdk as CLFiles
}

export const destroyFilesSdk = () => {
  CLFiles.destroy()
}
